import React from 'react'
import _get from 'lodash/get'
import toLower from 'lodash/toLower'
import compose from 'recompose/compose'
import kebabCase from 'lodash/kebabCase'
import { Map, List, fromJS } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import Tile from '../Tile/index'
import Link from '../Link/index'
import { get as getConfig } from '../../config/index'
import { getBoundActions } from '../../actions/index'
import { getPrimary } from '../../services/languages/index'
import EmailCapture from '../EmailCapture/index'
import { H3, H4 } from '../Heading/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_BUTTON } from '../ButtonSignUp/index'
import PlanCardGrid from '../PlanCardGrid/index'
import Row, { STYLES } from '../Row.v2/index'
import RowV3 from '../Row.v3/index'
import { connect as connectStaticText } from '../StaticText/connect'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../Page/connect'
import Jumbotron from '../JumbotronSubcategory/index'
import LoadMore from '../LoadMore/index'
import {
  createUpstreamContext,
  SCREEN_TYPE_YOGA_HOME,
} from '../../services/upstream-context/index'
import {
  ARTICLE_CLICKED_GA4_EVENT,
  PLAY_CLICK_GA4_EVENT,
  CLICK_TO_DETAILS_PAGE_GA4_EVENT,
} from '../../services/event-tracking/index'
import { selectVideos, selectSeries, getSafeNodeId } from '../../services/node/index'
import Button, { TYPES } from '../Button/index'
import {
  TYPE_CONTENT_LIST,
  TYPE_HEADER,
  TYPE_PEOPLE_LIST,
  TYPE_LINK,
  TYPE_ARTICLE_LIST,
  TYPE_PLAN_SELECTION,
  TYPE_EMAIL_SIGNUP,
  TYPE_CONTENT_REFERENCES_LIST,
  getPmSectionTabs,
} from '../../services/pm-section/index'
import {
  selectHomeSections,
  selectHomeLoadMoreSections,
  loadMoreSectionsStatus,
  sectionStatus,
} from '../../services/page-manager/index'

import articlesJSON from './articles.json'

const config = getConfig()
const rowV3Active = !!_get(config, ['features', 'rowV3'])

const upstreamContext = createUpstreamContext({
  screenType: SCREEN_TYPE_YOGA_HOME,
  contextType: SCREEN_TYPE_YOGA_HOME,
})

const CONTENT_LIST_DISPLAY_MODE_LEGACY1 = {
  teaser: true,
  heroLabel: true,
  hideArrows: true,
  maxItemsInView: 4,
  playlistButton: true,
}

const CONTENT_LIST_DISPLAY_MODE_LEGACY2 = {
  teaser: true,
  hideArrows: true,
  maxItemsInView: 4,
  playlistButton: true,
}

const CONTENT_LIST_DISPLAY_MODE_LEGACY3 = {
  moreInfo: true,
}

const CONTENT_LIST_DISPLAY_MODE_LEGACY4 = {
}

const CONTENT_LIST_DISPLAY_MODE_LEGACY5 = {
  playlistButton: true,
}

const CONTENT_LIST_DEFAULT_DISPLAY_MODE = CONTENT_LIST_DISPLAY_MODE_LEGACY5

function getRenderRowOptions (displayMode) {
  switch (displayMode) {
    case 'legacy-row1':
      return CONTENT_LIST_DISPLAY_MODE_LEGACY1
    case 'legacy-row2':
      return CONTENT_LIST_DISPLAY_MODE_LEGACY2
    case 'legacy-row3':
      return CONTENT_LIST_DISPLAY_MODE_LEGACY3
    case 'legacy-row4':
      return CONTENT_LIST_DISPLAY_MODE_LEGACY4
    case 'legacy-row5':
      return CONTENT_LIST_DISPLAY_MODE_LEGACY5
    default:
      return CONTENT_LIST_DEFAULT_DISPLAY_MODE
  }
}

function getArticleData () {
  return fromJS(articlesJSON)
}

function checkoutPicker (auth, props) {
  const { history } = props

  if (auth.get('jwt')) {
    return null
  }

  return (
    <div className="yoga-home__checkout-picker">
      <PlanCardGrid history={history} />
    </div>
  )
}

function legacyRenderEmailCapture (props, testClass) {
  const { emailSignup, doEmailSignup } = props
  return (
    <div className="yoga-home__email-signup-form">
      <EmailCapture
        formName="MY_RI-95_WebApp_My_Yoga_Home_Testarossa_Campaign"
        success={emailSignup.get('success')}
        siteSegment={Map()}
        className={['footer-email-capture__email-capture', testClass]}
        onFormSubmit={doEmailSignup}
        uiLocation="Yoga Home"
      />
    </div>
  )
}

function renderButtonLink (options) {
  const {
    text,
    classes = List(),
  } = options
  const buttonClassName = [
    'yoga-home__button-link-button',
    'button--primary',
    'button--small',
    'button--last',
  ]
  if (classes.size) {
    buttonClassName.push(...classes)
  }
  return (
    <div className="yoga-home__button-link">
      <ButtonSignUp
        text={text}
        buttonClass={buttonClassName}
        type={BUTTON_SIGN_UP_TYPE_BUTTON}
        scrollToTop
      />
    </div>
  )
}

function legacyRenderLink (auth, options) {
  const {
    text,
    url,
    anon,
    member,
    classes = List(),
  } = options

  const baseClass = 'yoga-home__view-more-link'
  const className = classes.size ? classes.push(baseClass).join(' ') : baseClass
  const link = <div className="yoga-home__link-wrapper"><Link className={className} to={url}>{text}</Link></div>

  if (auth.get('jwt') && member) {
    return link
  }

  if (anon) {
    return link
  }

  return null
}

function renderSimpleLink (options) {
  const {
    text,
    url,
    classes = List(),
  } = options

  const baseClass = 'yoga-home__view-more-link'
  const className = classes.size ? classes.push(baseClass).join(' ') : baseClass
  return (
    <div className="yoga-home__link-wrapper">
      <Link
        className={className}
        to={url}
      >
        {text}
      </Link>
    </div>
  )
}

function renderLinkSection (section) {
  const linkText = section.getIn(['data', 'linkText'])
  const linkUrl = section.getIn(['data', 'linkUrl'])
  const displayMode = section.getIn(['data', 'displayMode'])
  const id = section.get('id')
  if (!linkText || !linkUrl) {
    return null
  }

  if (displayMode === 'button') {
    return renderButtonLink({ text: linkText, url: linkUrl, id })
  }

  return renderSimpleLink({ text: linkText, url: linkUrl })
}

class YogaHome extends React.Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      activeTabs: Map(),
    }
  }

  componentDidMount () {
    const { props } = this
    const { setUpstreamContext } = props
    setUpstreamContext(upstreamContext)
  }

  articleClicked = (title) => {
    const { props } = this
    const { setEventDefault } = props

    setEventDefault(
      ARTICLE_CLICKED_GA4_EVENT.mergeDeep({
        ui_element: 'Yoga Article',
        ui_location: 'Yoga Home',
        ...(title && { article_name: title }),
      }),
    )
  }

  legacyRenderArticle = (articleKey) => {
    const articleData = getArticleData()
    const articles = articleData.get('articles')
    const article = articles.find((a) => a.get('id') === articleKey)
    const title = article.get('title')

    if (article) {
      const id = article.get('id', '')
      const className = toLower(id)
      return (
        <div key={id} className="yoga-home__article">
          <Link
            className={`yoga-home__article-img yoga-home__article-img--${className}`}
            to={article.get('url', '')}
            onClick={() => this.articleClicked(title)}
          />
          <Link className="yoga-home__article-desc" to={article.get('url', '')} onClick={() => this.articleClicked()}>
            {title}
          </Link>
        </div>
      )
    }
    return null
  }

  signUpButton = (auth) => {
    if (auth.get('jwt')) {
      return null
    }
    const { props } = this
    const { staticText } = props
    const text = staticText.getIn(['data', 'signUpToStartPracticing'])
    const buttonClassName = [
      'yoga-home__btn-signup-btn',
      'button--primary',
      'button--small',
      'button--last',
    ]
    return (
      <div className="yoga-home__btn-signup">
        <ButtonSignUp
          text={text}
          buttonClass={buttonClassName}
          type={BUTTON_SIGN_UP_TYPE_BUTTON}
          scrollToTop
        />
      </div>
    )
  }

  emailSignup = () => {
    const { props } = this
    const { auth, staticText } = props
    if (auth.get('jwt')) {
      return null
    }
    return (
      <div className="yoga-home__email-signup">
        <div className="yoga-home__email-signup-title">
          {staticText.getIn(['data', 'signUpForFreeVideos'])}
        </div>
        {legacyRenderEmailCapture(props)}
      </div>
    )
  }

  changeTab = (e, sectionId, index) => {
    e.preventDefault()
    this.setState(() => {
      const { activeTabs } = this.state
      return {
        activeTabs: activeTabs.set(sectionId, index),
      }
    })
  }

  pillTabs = (section = Map(), activeTabIndex) => {
    const { changeTab, props } = this
    const { pmSection } = props
    const sectionId = section.get('id')
    const tabs = getPmSectionTabs({ sectionId, pmSection })
    return tabs.size > 1
      ? (
        <ul className="yoga-home__pilltabs">
          {tabs.map((tab, index) => {
            const label = tab.get('tabLabel')
            const tabContent = tab.get('tabContent', List())
            // Don't render tab if tab content is missing
            if (tabContent.isEmpty()) {
              return null
            }
            const activeClass = activeTabIndex === index ? ' active' : ''
            return (
              <li key={`pilltab-${sectionId}-${index}-${kebabCase(label || '')}`}>
                <Button
                  type={TYPES.GHOST}
                  onClick={(e) => changeTab(
                    e,
                    sectionId,
                    index,
                  )}
                  className={`yoga-home__pilltab-btn${activeClass}`}
                  label={`View videos related to ${label}`}
                >
                  {label}
                </Button>
              </li>
            )
          })}
        </ul>
      ) : null
  }

  renderHeaderSection = (section) => {
    const { props } = this
    const {
      auth, staticText, setOverlayDialogVisible,
    } = props
    // For header sections, GraphQL structure is: section.app.data which is
    // PMSectionAppDataHeaderSection. It has imageId, imageUrl, title, description,
    // and asset fields. Title and description are provided directly on the section
    // by the GraphQL resolver (no need to manually look up pmList).
    // Use top-level asset.renderUrl for the image URL (preferred), fallback to imageUrl
    // Note: section is already the 'app' object from Redux, so section.data is the union type
    const assetRenderUrl = section.getIn(['data', 'asset', 'renderUrl'])
    const imageUrl = assetRenderUrl || section.getIn(['data', 'imageUrl'], '')
    const title = section.getIn(['data', 'title'], '')
    const description = section.getIn(['data', 'description'], '')

    return (
      <Jumbotron
        auth={auth}
        description={description}
        title={title}
        setOverlayDialogVisible={setOverlayDialogVisible}
        staticText={staticText}
        heroImage={Map({
          large: imageUrl,
          medium: imageUrl,
          mediumSmall: imageUrl,
          small: imageUrl,
        })}
      />
    )
  }

  renderContentList = (section) => {
    const {
      props, state, renderRow, renderTile, pillTabs,
    } = this
    const { pmSection } = props
    const sectionId = section.get('id')
    const activeTabs = _get(state, 'activeTabs', Map())
    const activeTabIndex = activeTabs.get(sectionId, 0)
    const headerLabel = section.getIn(['data', 'header', 'label'], '')
    // const footerLabel = section.getIn(['data', 'footer', 'label'], '')
    const listId = section.getIn(['data', 'content', activeTabIndex, 'listId'])
    const listLabel = section.getIn(['data', 'content', activeTabIndex, 'label'])
    const adminTitle = section.get('adminTitle')
    const tabs = getPmSectionTabs({ sectionId, pmSection })
    let listItems = tabs.getIn([activeTabIndex, 'tabContent'], List())
    // let listItems = contentList.get('listItems', List())
    listItems = listItems.map((item, index) => {
      return item.set('index', index)
        .set('sectionId', sectionId)
        .set('listId', listId)
        .set('listLabel', listLabel)
        .set('adminTitle', adminTitle)
        .set('headerLabel', headerLabel)
    })
    const displayMode = section.getIn(['data', 'displayMode'])
    const renderRowOptions = getRenderRowOptions(displayMode)
    const classNames = ['yoga-home__content-list', 'yoga-home__row--overstretch']
    if (displayMode) {
      classNames.push(`yoga-home__content-list-${displayMode}`)
    }
    return (
      <div className="yoga-home__wrapper">
        <div className={classNames.join(' ')}>
          <H4 className="yoga-home__section-title">
            <span>
              {headerLabel}
            </span>
          </H4>
          {pillTabs(section, activeTabIndex)}
          {renderRow(listItems, renderTile, renderRowOptions)}
          {/* TODO: render footer link from section footer data
          renderSimpleLink({
            text: footerLabel,
            url: '/yoga/practices',
            anon: false,
            member: true,
          })
          */}
        </div>
      </div>
    )
  }

  renderPeopleList = (section) => {
    const {
      props, state, renderRow, renderTeacher, pillTabs,
    } = this
    const { pmSection } = props
    const sectionId = section.get('id')
    const activeTabs = _get(state, 'activeTabs', Map())
    const activeTabIndex = activeTabs.get(sectionId, 0)
    const headerLabel = section.getIn(['data', 'header', 'label'], '')
    // const footerLabel = section.getIn(['data', 'footer', 'label'], '')
    const tabs = getPmSectionTabs({ sectionId, pmSection })
    const activeTab = tabs.get(activeTabIndex)
    const displayMode = section.getIn(['data', 'displayMode'])
    const renderRowOptions = getRenderRowOptions(displayMode)
    const adminTitle = section.get('adminTitle')
    const listId = section.getIn(['data', 'content', activeTabIndex, 'listId'])
    let listItems = activeTab ? activeTab.get('tabContent', List()) : List()
    listItems = listItems.map((item, index) => {
      return item
        .set('index', index)
        .set('sectionId', sectionId)
        .set('listId', listId)
        .set('adminTitle', adminTitle)
        .set('headerLabel', headerLabel)
    })

    const classNames = ['yoga-home__people-list', 'yoga-home__row--overstretch']
    if (displayMode) {
      classNames.push(`yoga-home__people-list-${displayMode}`)
    }

    return (
      <div className="yoga-home__wrapper">
        <div className={classNames.join(' ')}>
          <H4 className="yoga-home__section-title">
            <span>{headerLabel}</span>
          </H4>
          {pillTabs(section, activeTabIndex)}
          { renderRow(listItems, renderTeacher, renderRowOptions) }
          {/* TODO: render footer link from section footer data
          renderSimpleLink({
            text: footerLabel,
            url: '/yoga/teachers',
            anon: false,
            member: true,
          })
          //TODO: add tracking event for footer
          */}
        </div>
      </div>
    )
  }

  renderTile = (item = Map(), renderOptions) => {
    const { props } = this
    const {
      series = Map(),
      videos = Map(),
      auth,
      user,
      setEventDefault,
    } = props

    const userLanguage = getPrimary(user.getIn(['data', 'language'], 'en'))
    const {
      playlistButton = false,
      heroLabel = false,
      teaser = false,
    } = renderOptions

    let node = Map()
    const itemId = item ? item.get('contentId') : null
    let itemIndex
    let listId
    let listLabel
    let sectionId
    let headerLabel
    if (itemId && itemId > 0) {
      itemIndex = item.get('index')
      listId = item.get('listId')
      listLabel = item.get('listLabel')
      sectionId = item.get('sectionId')
      headerLabel = item.get('headerLabel')
      if (item.get('contentType') === 'video') {
        node = videos.getIn([getSafeNodeId(itemId), userLanguage, 'data'], Map())
      }
      if (item.get('contentType') === 'series') {
        node = series.getIn([getSafeNodeId(itemId), userLanguage, 'data'], Map())
      }
    }

    const onClickWatch = (eventData) => {
      const parentSeriesId = node.get('seriesId')
      let ga4EventData = eventData.hasPlayIcon
        ? PLAY_CLICK_GA4_EVENT
        : CLICK_TO_DETAILS_PAGE_GA4_EVENT

      ga4EventData = ga4EventData.mergeDeep({
        content_id: itemId,
        content_name: node.get('title'),
        content_type: item.get('type'),
        media_id: node.getIn(['feature', 'id']),
        media_language: node.get('mediaLanguage'),
        is_featured_media: true,
        ui_element: 'Tile',
        ui_location: 'Yoga Home',
      })

      if (parentSeriesId) {
        ga4EventData = ga4EventData.mergeDeep({
          parent_series_name: node.get('seriesTitle'),
          parent_series_id: parentSeriesId,
        })
      }

      setEventDefault(ga4EventData)
    }

    if (node && node.get('id') > 0) {
      const tileData = node.setIn(['reason', 'source'], SCREEN_TYPE_YOGA_HOME)
        .setIn(['reason', 'sectionId'], sectionId)
        .setIn(['reason', 'listId'], listId)
        .setIn(['reason', 'listLabel'], listLabel)
        .setIn(['reason', 'itemIndex'], itemIndex)
        .setIn(['reason', 'headerLabel'], headerLabel)
      return (
        <Tile
          heroLabel={heroLabel ? node.get('heroLabel') : null}
          addToPlaylist={playlistButton}
          tileClass="tile--row-item"
          showMoreInfo={false}
          key={itemId}
          showTeaser={teaser}
          tileData={tileData}
          auth={auth}
          upstreamContext={upstreamContext}
          onClickWatch={onClickWatch}
          single
        />
      )
    }

    return (
      <div className="tile-placeholder" key={renderOptions.index}>
        <div className="tile-placeholder__hero" />
        <div className="tile-placeholder__text" />
        <div className="tile-placeholder__text" />
      </div>
    )
  }

  // eslint-disable-next-line class-methods-use-this
  renderTeacher = (teacher = Map(), renderOptions) => {
    if (!teacher) {
      return null
    }
    const { someOption } = renderOptions
    const name = teacher.get('name', '')
    const imageUrl = teacher.get('imageUrl')
    const linkUrl = teacher.get('linkUrl')
    const stylesText = teacher.get('description')

    const classNames = ['yoga-home__teacher']
    if (someOption) {
      classNames.push(`yoga-home__teacher-${someOption}`)
    }
    return (
      <div key={name} className={classNames.join(' ')}>
        <Link
          className="yoga-home__teacher__avatar"
          to={linkUrl}
        >
          <span className="yoga-home__teacher__avatar-inner" />
          <div>
            <img
              className="yoga-home__teacher__avatar-img"
              alt="Teacher"
              src={imageUrl}
            /></div>
        </Link>
        <H3>
          <Link to={linkUrl}>
            {name}
          </Link>
        </H3>
        <H4>{stylesText}</H4>
      </div>
    )
  }

  renderRow = (items = List(), renderer, options = {}) => {
    const { props } = this
    const { auth } = props

    if (rowV3Active) {
      return (
        <RowV3 style={STYLES.S12234}>
          {items.map((item, index) => renderer(item, { index, ...options }, props))}
        </RowV3>
      )
    }

    return (
      <Row
        items={items}
        auth={auth}
        createAccessor={() => null}
        style={STYLES.S12234}
        disableHover
      >{(item) => renderer(item, options)}
      </Row>
    )
  }

  renderLegacyRow = (items = List(), renderer, options = {}) => {
    const { props } = this
    const { auth } = props

    if (rowV3Active) {
      return (
        <RowV3 style={STYLES.S12234}>
          {items.map((item) => renderer(item, options, props))}
        </RowV3>
      )
    }

    return (
      <Row
        items={items}
        auth={auth}
        createAccessor={() => null}
        style={STYLES.S12234}
        disableHover
      >{(item) => renderer(item, options, props)}
      </Row>
    )
  }

  renderLegacyArticlesRow = () => {
    const { props, renderLegacyRow } = this
    const { auth, user } = props
    const userLanguage = getPrimary(user.getIn(['data', 'language'], 'en'))
    const articleData = getArticleData()
    const articleKeys = articleData.get('articleKeys', List())

    if (userLanguage !== 'en') {
      return null
    }

    return (
      <div className="yoga-home__wrapper">
        <div className="yoga-home__articles yoga-home__row--overstretch">
          <H4 className="yoga-home__section-title">
            <span>
              {articleData.get('rowTitle', '')}
            </span>
          </H4>
          {renderLegacyRow(articleKeys, this.legacyRenderArticle, {
            maxItemsInView: 4,
          })}
          {legacyRenderLink(auth, {
            text: 'See More Yoga Poses',
            url: 'https://www.gaia.com/articles/yoga-poses',
            anon: true,
            member: true,
            classes: List(['yoga-home__view-more-link__articles']),
          })}
        </div>
      </div>
    )
  }

  renderPlanSelection = () => {
    const {
      props,
    } = this
    const { auth } = props // plans

    return (
      <div className="yoga-home__plans">
        {checkoutPicker(auth, props)}
      </div>
    )
  }

  renderSection = (sectionId) => {
    const {
      props,
      renderHeaderSection,
      renderContentList,
      renderPeopleList,
      emailSignup,
      renderLegacyArticlesRow,
      renderPlanSelection,
    } = this
    const { pmSection } = props
    const section = pmSection.getIn([sectionId, 'data'], Map())
    const type = section.get('type')
    const zuoraOutage = _get(config, ['features', 'zuoraOutage'])

    if (type === TYPE_HEADER) {
      return renderHeaderSection(section)
    }

    if (type === TYPE_CONTENT_LIST || type === TYPE_CONTENT_REFERENCES_LIST) {
      return renderContentList(section)
    }

    if (type === TYPE_PEOPLE_LIST) {
      return renderPeopleList(section)
    }

    if (type === TYPE_LINK) {
      return renderLinkSection(section)
    }

    if (type === TYPE_EMAIL_SIGNUP) {
      return emailSignup()
    }

    if (type === TYPE_ARTICLE_LIST) {
      return renderLegacyArticlesRow()
    }

    if (type === TYPE_PLAN_SELECTION && !zuoraOutage) {
      return renderPlanSelection()
    }

    return null
  }

  renderSections = (sections) => {
    const { renderSection } = this
    if (!sections || sections.status === sectionStatus.EMPTY) {
      return null
    }
    // Convert Immutable List to array FIRST, then map
    // React cannot render Immutable Lists directly
    const itemsArray = sections.items.toArray ? sections.items.toArray() : sections.items
    return itemsArray.map(({ sectionId }) => {
      const rendered = renderSection(sectionId)

      if (!rendered) {
        return null
      }

      return (
        <div key={sectionId}>{rendered}</div>
      )
    })
  }

  onLoadMore = (sectionId) => {
    const { props } = this
    const { fetchSection } = props
    if (fetchSection && sectionId) {
      fetchSection(sectionId)
    }
  }

  renderLoadMore = () => {
    const { props } = this
    const { loadMoreSections } = props
    if (!loadMoreSections) {
      return null
    }
    const {
      status, processing, currentCount, totalCount, nextSectionId,
    } = loadMoreSections

    if (status === loadMoreSectionsStatus.EMPTY || !nextSectionId) {
      return null
    }

    return (
      <div className="yoga-home__load-more">
        <LoadMore
          onLoadMore={() => this.onLoadMore(nextSectionId)}
          buttonClassName={['button--secondary']}
          currentCount={currentCount}
          totalCount={totalCount}
          processing={processing}
          infiniteScroll
          visibilityThreshold={0.01}
        />
      </div>
    )
  }

  render () {
    const {
      props,
      renderSections,
      renderLoadMore,
    } = this
    const { sections } = props
    return (
      <div className="yoga-home">
        {
          renderSections(sections)
        }
        {renderLoadMore()}
      </div>
    )
  }
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      plans: state.plans,
      pmScreen: state.pmScreen,
      pmSection: state.pmSection,
      series: selectSeries(state),
      videos: selectVideos(state),
      emailSignup: state.emailSignup,
      upstreamContext: state.upstreamContext.get('data', Map()),
      sections: selectHomeSections(state),
      loadMoreSections: selectHomeLoadMoreSections(state),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignup,
        getPmScreen: actions.pmScreen.getPmScreen,
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        setEventDefault: actions.eventTracking.setEventDefault,
        fetchSection: actions.pageManagerActions.fetchSection,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      }
    },
  ),
  connectStaticText({ storeKey: 'yogaHomePage' }),
)(YogaHome)
